import axios from 'axios';

const disableEnableAutoCoopUser = async (
  action: 'disable' | 'enable',
  userId: string,
) => {
  const config = {
    url: `user/auto_coop/${action}`,
    method: 'post',
    data: { coopingUserId: userId },
  };

  const { data } = await axios.request(config);

  return data;
};

export default disableEnableAutoCoopUser;
